
function ErrorComponent() {
    return (
      <div className="ErrorComponent">
        <h1>ErrorComponent</h1>
        <div>Invalid URL - we are working hard to fix all 404 errors</div>
      </div>
    )
  }   
  
  
    export default ErrorComponent;  